import { useState } from 'react';
import { Icon } from '@pace/ui';

/** Camera / gallery picker styled as a button (opens the back camera on phones). */
export function PhotoButton({
  onFile,
  label,
  disabled,
}: {
  onFile: (f: File) => void;
  label: string;
  disabled?: boolean;
}) {
  const [id] = useState(() => `photo-${Math.random().toString(36).slice(2)}`);
  return (
    <>
      <input
        id={id}
        type="file"
        disabled={disabled}
        accept="image/*"
        capture="environment"
        className="visually-hidden"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) onFile(f);
          e.target.value = '';
        }}
      />
      <label htmlFor={id} className="btn btn--line btn--sm" style={{ cursor: 'pointer' }}>
        <Icon name="camera" />
        {label}
      </label>
    </>
  );
}
